import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PopoverPayload<T = unknown> {
  template: TemplateRef<T> | null;
  context?: T;
}

@Injectable({ providedIn: 'root' })
export class SubHeaderPopoverService<T = unknown> {
  private readonly catInAppCount = new BehaviorSubject<number>(null);
  catInAppCount$ = this.catInAppCount.asObservable();

  private readonly _state = new BehaviorSubject<PopoverPayload>({ template: null });
  popover$ = this._state.asObservable();

  set(template: TemplateRef<T>, context?: T) {
    this._state.next({ template, context });
  }

  clear() {
    this._state.next({ template: null });
  }

  setcatInAppCount(count: number) {
    this.catInAppCount.next(count);
  }
}
